import { createSlice } from '@reduxjs/toolkit'
import baseReducers from 'apiV2/store/base/reducers'
import baseInitialState from 'apiV2/store/base/initialState'

import {
  createAUSSettingAPI,
  showAUSSettingAPI,
} from './asyncActions'

const ausSettingSlice = createSlice({
  name: 'ausSetting',
  initialState: baseInitialState,
  reducers: baseReducers,
  extraReducers: {
    [showAUSSettingAPI.pending](state) {
      state.uiFlags.isFetchingItem = true
    },
    [showAUSSettingAPI.fulfilled](state, action) {
      state.uiFlags.isFetchingItem = false
      state.stagedRecord = action.payload
    },
    [showAUSSettingAPI.rejected](state) {
      state.uiFlags.isFetchingItem = false
    },
    [createAUSSettingAPI.pending](state) {
      state.uiFlags.isCreating = true
    },
    [createAUSSettingAPI.fulfilled](state, action) {
      state.uiFlags.isCreating = false
      state.stagedRecord = { ...state.stagedRecord, ...action.payload }
    },
    [createAUSSettingAPI.rejected](state) {
      state.uiFlags.isCreating = false
    },
  },
})

export default ausSettingSlice
